var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g3, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _g4, _path73, _path74, _path75, _g5, _path76, _path77, _path78, _path79, _g6, _path80, _path81, _path82, _path83, _g7, _path84, _path85, _path86, _path87, _g8, _path88, _path89, _path90, _path91, _path92, _g9, _path93, _path94, _path95, _g0, _path96, _path97, _path98, _g1, _path99, _path100, _path101, _g10, _path102, _path103, _path104, _g11, _path105, _path106, _path107, _g12, _path108, _path109, _path110, _path111, _path112, _g13, _path113, _path114, _path115, _g14, _path116, _path117, _path118, _g15, _path119, _path120, _path121, _g16, _path122, _path123, _path124, _g17, _path125, _path126, _path127, _g18, _path128, _path129, _path130, _g19, _path131, _path132, _path133, _g20, _path134, _path135, _path136, _g21, _path137, _path138, _path139, _path140, _g22, _path141, _path142, _path143, _path144, _g23, _path145, _path146, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoreGoStopIntro1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 730,
    viewBox: "0 0 360 730",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 730,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3346_410798)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 730,
    fill: "#282828"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.9263 47.544C53.5743 47.544 51.6543 46.376 51.6543 44.088V42.392C51.6543 40.12 53.5743 38.936 55.9263 38.936C58.2783 38.936 60.1983 40.12 60.1983 42.392V44.088C60.1983 46.376 58.2783 47.544 55.9263 47.544ZM65.1263 49.496H63.5263V38.952H65.1263V49.496ZM55.9423 46.2C57.4463 46.2 58.5983 45.464 58.5983 44.024V42.472C58.5983 41.032 57.4463 40.28 55.9423 40.28C54.4062 40.28 53.2543 41.032 53.2543 42.472V44.024C53.2543 45.464 54.4062 46.2 55.9423 46.2ZM65.4143 53.544H52.5182V48.664H54.1183V52.2H65.4143V53.544ZM80.1343 44.68H78.5183L78.9983 40.504H68.1503V39.16H80.7583L80.1343 44.68ZM81.6703 47.096H67.1423V45.752H81.6703V47.096ZM80.9183 53.544H68.1343V48.36H69.7343V52.2H80.9183V53.544ZM90.2143 45.096H92.5503V38.952H94.1503V53.544H92.5503V46.44H90.2143V49.912C90.2143 51.816 88.8063 53.112 86.9343 53.112C85.0623 53.112 83.6543 51.816 83.6543 49.912V42.296C83.6543 40.392 85.0623 39.096 86.9343 39.096C88.8063 39.096 90.2143 40.392 90.2143 42.296V45.096ZM95.6863 53.544V38.952H97.2863V53.544H95.6863ZM88.6143 49.912V42.296C88.6143 41.192 87.9103 40.44 86.9343 40.44C85.9583 40.44 85.2543 41.192 85.2543 42.296V49.912C85.2543 51.048 85.9583 51.768 86.9343 51.768C87.9103 51.768 88.6143 51.048 88.6143 49.912ZM218.352 44.648H205.728V41.224H216.672V40.504H205.728V39.16H218.272V42.504H207.328V43.304H218.352V44.648ZM219.264 46.92H204.736V45.576H219.264V46.92ZM218.512 53.544H205.728V50.024H216.672V49.192H205.728V47.848H218.272V51.304H207.328V52.2H218.512V53.544ZM238.621 53.544H237.021V38.952H238.621V44.936H240.989V46.28H238.621V53.544ZM225.965 53.032V51.608C230.301 50.536 232.605 47.176 232.589 40.968H226.045V39.624H234.189V40.776C234.189 48.088 231.165 52.008 225.965 53.032ZM255.405 53.544H253.805V38.952H255.405V53.544ZM241.661 52.824V51.096C243.341 50.28 245.885 47.944 245.885 44.136V41.064H242.077V39.72H251.293V41.064H247.485V44.136C247.485 47.944 250.029 50.28 251.709 51.096V52.824C249.709 52.04 247.389 49.928 246.685 47.48C245.981 49.928 243.661 52.04 241.661 52.824ZM270.429 49.752H268.829L269.453 40.68H258.445V39.336H271.149L270.429 49.752ZM272.061 53.112H257.533V51.768H263.085V45.24H264.685V51.768H272.061V53.112ZM291.642 53.544H290.042V38.952H291.642V44.936H293.786V46.28H291.642V53.544ZM283.658 47.72C281.242 47.72 279.242 46.536 279.242 44.136V42.696C279.242 40.296 281.242 39.08 283.658 39.08C286.058 39.08 288.074 40.296 288.074 42.696V44.136C288.074 46.536 286.058 47.72 283.658 47.72ZM283.658 46.376C285.242 46.376 286.474 45.544 286.474 44.152V42.68C286.474 41.256 285.242 40.424 283.658 40.424C282.09 40.424 280.842 41.256 280.842 42.68V44.152C280.842 45.544 282.09 46.376 283.658 46.376ZM289.242 52.44L278.426 53.176V51.832L282.922 51.528V48.424H284.522V51.416L289.242 51.096V52.44ZM306.602 45.704H302.842V44.36H306.602V38.952H308.202V53.544H306.602V45.704ZM294.458 52.824V51.096C296.154 50.072 298.602 47.608 298.602 43.816V39.368H300.202V43.816C300.202 47.608 302.634 50.072 304.33 51.096V52.824C302.346 51.816 300.058 49.544 299.402 47.048C298.73 49.544 296.442 51.816 294.458 52.824Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.707 46.632C106.243 46.632 104.243 45.448 104.243 43.16V42.344C104.243 40.024 106.243 38.824 108.707 38.824C111.155 38.824 113.155 40.024 113.155 42.344V43.16C113.155 45.448 111.155 46.632 108.707 46.632ZM118.275 46.952H115.171V38.824H118.275V46.952ZM108.707 44.584C109.523 44.584 110.179 44.136 110.179 43.432V42.056C110.179 41.352 109.523 40.872 108.707 40.872C107.859 40.872 107.235 41.352 107.235 42.056V43.432C107.235 44.136 107.859 44.584 108.707 44.584ZM115.203 53.208L104.931 53.64V47.416H118.275V53.64H115.203V53.208ZM108.003 49.624V51.288L115.203 51.016V49.624H108.003ZM130.579 53.64H128.035V38.824H130.579V44.392H131.811V38.824H134.451V53.64H131.811V47H130.579V53.64ZM127.459 52.472L120.259 53.128V39.336H126.979V41.8H122.947V50.328L127.459 49.912V52.472ZM136.019 53.112V49.976C137.875 49.032 139.331 47.336 139.331 43.752V43.016H136.179V40.504H139.315V38.648H142.339V40.504H145.475V43.016H142.339V43.752C142.339 47.336 143.779 49.016 145.635 49.976V53.112C143.555 52.44 141.779 50.92 140.819 48.888C139.891 50.92 138.099 52.44 136.019 53.112ZM149.763 53.64H146.723V38.824H149.763V44.328H151.539V47.064H149.763V53.64ZM167.76 53.64H165.264V46.984H162.288V44.504H165.264V38.824H167.76V53.64ZM171.248 53.64H168.688V38.824H171.248V53.64ZM164.592 52.472L157.056 53.128V39.336H163.904V41.8H159.744V50.328L164.592 49.912V52.472ZM187.072 53.64H183.968V38.824H187.072V53.64ZM177.472 53.368C175.008 53.368 173.04 51.768 173.04 49.448V42.968C173.04 40.632 175.008 39.048 177.472 39.048C179.952 39.048 181.952 40.632 181.952 42.968V49.448C181.952 51.768 179.952 53.368 177.472 53.368ZM177.52 50.904C178.416 50.904 179.056 50.312 179.056 49.592V42.808C179.056 42.136 178.416 41.48 177.52 41.48C176.608 41.48 175.984 42.136 175.984 42.808V49.592C175.984 50.312 176.608 50.904 177.52 50.904ZM203.072 53.64H200.032V48.616H196.32V46.072H200.032V38.824H203.072V53.64ZM197.776 41.8H189.056V39.336H197.776V41.8ZM198.864 52.456L189.056 53.128V42.824H197.584V45.224H192.112V50.328L198.864 49.832V52.456Z",
    fill: "#FDF647"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6014 88.96H82.8094V66.736H86.6014V75.088H88.5214V66.736H92.4814V88.96H88.5214V79H86.6014V88.96ZM81.9934 86.992L71.1934 88.192V67.384H75.4174V83.752L81.9934 83.032V86.992ZM114.989 75.424V77.68H123.821V81.208H101.813V77.68H110.597V75.424H102.797V66.784H122.813V70.024H107.429V72.136H122.933V75.424H114.989ZM102.797 82.264H107.309V85.648H123.173V88.96H102.797V82.264ZM141.053 79.912H132.533C129.005 79.912 126.509 77.032 126.509 73.48C126.509 69.88 129.005 67 132.533 67H141.053C144.605 67 147.101 69.88 147.101 73.48C147.101 77.032 144.605 79.912 141.053 79.912ZM133.781 76.168H139.853C141.389 76.168 142.469 75.04 142.469 73.48C142.469 71.944 141.389 70.792 139.853 70.792H133.781C132.245 70.792 131.165 71.944 131.165 73.48C131.165 75.04 132.245 76.168 133.781 76.168ZM147.821 88.552H125.813V84.568H147.821V88.552ZM171.053 80.248H150.797V71.968H166.277V70.48H150.797V67.12H170.813V75.184H155.357V76.768H171.053V80.248ZM171.821 88.552H149.813V84.688H158.477V81.064H163.133V84.688H171.821V88.552ZM201.864 78.352H197.304V66.736H201.864V70.432H204.504V74.248H201.864V78.352ZM181.272 77.872V74.32C184.488 73.552 186.12 71.488 186.12 68.44V66.88H190.656V68.608C190.704 71.56 192.336 73.552 195.504 74.32V77.872C192.288 77.416 189.768 76 188.4 73.84C187.008 76 184.464 77.416 181.272 77.872ZM202.344 88.96H182.568V82.672H197.304V81.688H182.568V79H201.864V85.096H187.128V86.176H202.344V88.96ZM213.043 77.176V73.36C218.011 73.336 220.891 70.192 220.891 67.72V67H225.523V67.72C225.523 70.192 228.403 73.336 233.371 73.36V77.176C228.235 77.152 224.851 75.112 223.195 72.784C221.515 75.112 218.227 77.152 213.043 77.176ZM225.523 89.2H220.867V82.792H212.203V78.952H234.211V82.792H225.523V89.2ZM250.647 78.424C246.951 78.424 243.951 76.648 243.951 73.192V72.016C243.951 68.536 246.951 66.736 250.647 66.736C254.319 66.736 257.319 68.536 257.319 72.016V73.192C257.319 76.648 254.319 78.424 250.647 78.424ZM264.999 78.928H260.343V66.736H264.999V78.928ZM250.647 75.352C251.871 75.352 252.855 74.68 252.855 73.624V71.584C252.855 70.528 251.871 69.808 250.647 69.808C249.375 69.808 248.439 70.528 248.439 71.584V73.624C248.439 74.68 249.375 75.352 250.647 75.352ZM254.943 89.32C252.663 88.864 251.055 87.592 250.143 86.176C249.111 87.688 247.143 88.888 244.191 88.96V85.336C246.831 85.072 247.959 83.176 247.959 81.304V80.104H252.087V81.304C252.087 83.272 253.359 85 254.943 85.504C256.815 85 257.967 83.152 258.015 81.16V79.864H262.119V81.088C262.119 82.96 263.055 84.976 266.055 85.24V88.96C263.223 88.888 261.231 87.688 260.103 86.2C259.119 87.616 257.367 88.864 254.943 89.32ZM288.519 74.8H268.383V66.64H272.871V71.488H288.519V74.8ZM289.407 80.248H267.399V76.648H289.407V80.248ZM288.759 88.96H268.383V81.496H272.943V85.456H288.759V88.96Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6059 118.55H57.0059V102.11H63.6059V107.24H66.7259V112.49H63.6059V118.55ZM37.5059 117.98V112.55C41.5859 111.35 43.1759 108.05 43.1759 104.21V102.26H49.7159V104.21C49.7159 108.05 51.3059 111.05 55.3859 112.25V117.68C51.2759 116.81 48.3959 115.07 46.4759 112.58C44.5859 115.22 41.6759 117.05 37.5059 117.98ZM38.7659 124.64C38.7659 121.43 41.3459 119.15 44.5859 119.15H58.3259C61.6259 119.15 64.2059 121.43 64.2059 124.64C64.2059 127.76 61.6259 130.13 58.3259 130.13H44.5859C41.3459 130.13 38.7659 127.76 38.7659 124.64ZM46.6859 125.6H56.1959C57.0359 125.6 57.6059 125.36 57.6059 124.64C57.6059 123.83 57.0359 123.65 56.1959 123.65H46.6859C45.9659 123.65 45.3959 123.83 45.3959 124.64C45.3959 125.36 45.9659 125.6 46.6859 125.6ZM93.0059 129.98H86.4059V102.11H93.0059V112.22H96.7259V117.95H93.0059V129.98ZM67.6559 129.38V123.65C74.4959 121.85 77.9459 117.08 77.9159 108.41H67.8059V103.01H84.1559V107.51C84.1559 120.59 78.0959 127.73 67.6559 129.38ZM98.2559 115.25V109.97C104.556 109.97 107.646 106.04 107.646 103.16V102.41H114.396V103.16C114.396 106.04 117.486 109.97 123.786 109.97V115.25C117.246 115.25 113.256 112.85 111.006 110.06C108.696 112.85 104.856 115.25 98.2559 115.25ZM114.396 130.28H107.616V122.54H97.2059V117.23H124.806V122.54H114.396V130.28ZM136.296 117.68C131.616 117.68 127.806 115.58 127.806 111.23V108.65C127.806 104.24 131.616 102.11 136.296 102.11C140.946 102.11 144.756 104.24 144.756 108.65V111.23C144.756 115.58 140.946 117.68 136.296 117.68ZM154.476 118.52H147.726V102.11H154.476V118.52ZM136.296 113.39C137.406 113.39 138.306 112.64 138.306 111.59V108.29C138.306 107.24 137.406 106.4 136.296 106.4C135.126 106.4 134.286 107.24 134.286 108.29V111.59C134.286 112.64 135.126 113.39 136.296 113.39ZM154.476 130.28H147.426V124.22H128.766V119.27H154.476V130.28ZM164.736 109.55H183.906V112.73H158.256V105.95H177.246V105.05H158.256V102.11H183.756V108.62H164.736V109.55ZM184.806 113.75V117.26H179.436V119H183.756V125.81H164.736V126.86H184.206V129.98H158.256V122.99H177.246V121.97H158.256V119H162.306L162.756 117.26H157.206V113.75H184.806ZM168.696 117.26L168.246 119H173.646V117.26H168.696Z",
    fill: "#FB4141"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M222.6 118.55H216V102.11H222.6V107.24H225.72V112.49H222.6V118.55ZM196.5 117.98V112.55C200.58 111.35 202.17 108.05 202.17 104.21V102.26H208.71V104.21C208.71 108.05 210.3 111.05 214.38 112.25V117.68C210.27 116.81 207.39 115.07 205.47 112.58C203.58 115.22 200.67 117.05 196.5 117.98ZM197.76 124.64C197.76 121.43 200.34 119.15 203.58 119.15H217.32C220.62 119.15 223.2 121.43 223.2 124.64C223.2 127.76 220.62 130.13 217.32 130.13H203.58C200.34 130.13 197.76 127.76 197.76 124.64ZM205.68 125.6H215.19C216.03 125.6 216.6 125.36 216.6 124.64C216.6 123.83 216.03 123.65 215.19 123.65H205.68C204.96 123.65 204.39 123.83 204.39 124.64C204.39 125.36 204.96 125.6 205.68 125.6ZM253.47 129.98H246.72V102.11H253.47V129.98ZM238.44 115.91H233.04C229.41 115.91 226.8 112.91 226.8 109.16C226.8 105.41 229.41 102.41 233.04 102.41H238.44C242.07 102.41 244.68 105.41 244.68 109.16C244.68 112.91 242.07 115.91 238.44 115.91ZM234.12 111.08H237.36C238.23 111.08 238.92 110.18 238.92 109.19C238.92 108.11 238.23 107.24 237.36 107.24H234.12C233.28 107.24 232.62 108.14 232.62 109.19C232.62 110.18 233.28 111.08 234.12 111.08ZM236.91 129.98H230.28L232.26 121.91H226.2V117.11H245.97V121.91H238.89L236.91 129.98ZM266.244 102.11H291.744V111.2H266.244V102.11ZM272.574 107.36H285.414V105.95H272.574V107.36ZM292.794 112.28V116.63H282.144V118.04H291.744V125.42H272.814V126.5H292.194V129.98H266.244V122.33H285.144V121.34H266.244V118.04H275.814V116.63H265.194V112.28H292.794ZM315.864 114.47H309.264C306.084 117.71 300.924 119 295.644 119V114.2C303.054 114.2 306.444 110.81 306.444 107.36H295.794V102.56H312.534V105.86C312.534 107.15 312.384 108.29 312.114 109.37H315.864V102.11H322.494V122.66H315.864V114.47ZM303.744 120.14V125.06H322.944V129.98H297.054V120.14H303.744Z",
    fill: "#79FB41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.967 169.544H109.367V154.952H110.967V169.544ZM104.375 168.104L97.7034 168.872V155.624H105.975V168.872H104.375V168.104ZM99.3034 156.968V167.336L104.375 166.744V156.968H99.3034ZM113.623 163.224V161.88C116.775 161.672 119.559 159.32 119.559 157.064V155.176H121.159V157.064C121.159 159.32 123.959 161.672 127.095 161.88V163.224C123.927 163.096 121.207 161.288 120.359 159.224C119.511 161.288 116.791 163.096 113.623 163.224ZM127.623 169.112H113.095V167.768H127.623V169.112ZM141.991 165.752H140.391L141.015 156.68H130.007V155.336H142.711L141.991 165.752ZM143.623 169.112H129.095V167.768H134.647V161.24H136.247V167.768H143.623V169.112ZM156.164 166.184H151.78L151.044 169.416H149.428L152.788 155.032H155.172L158.548 169.416H156.9L156.164 166.184ZM155.876 164.856L153.972 156.44L152.068 164.856H155.876ZM160.029 155.032H161.629V169.416H160.029V155.032ZM176.668 169.544H175.068V154.952H176.668V160.936H179.036V162.28H176.668V169.544ZM164.012 169.032V167.608C168.348 166.536 170.652 163.176 170.636 156.968H164.092V155.624H172.236V156.776C172.236 164.088 169.212 168.008 164.012 169.032ZM188.873 162.424C186.633 162.424 184.793 161.32 184.793 159.128V158.232C184.793 156.056 186.633 154.936 188.873 154.936C191.113 154.936 192.953 156.056 192.953 158.232V159.128C192.953 161.32 191.113 162.424 188.873 162.424ZM197.785 162.584H196.185V154.952H197.785V157.784H199.833V159.128H197.785V162.584ZM188.889 161.08C190.281 161.08 191.353 160.408 191.353 159.064V158.312C191.353 156.968 190.281 156.28 188.889 156.28C187.465 156.28 186.393 156.968 186.393 158.312V159.064C186.393 160.408 187.465 161.08 188.889 161.08ZM198.105 169.544H185.561V165.752H196.185V164.664H185.561V163.32H197.785V167.032H187.161V168.2H198.105V169.544ZM212.745 163.992H209.321V162.648H212.745V159.752H209.321V158.408H212.745V154.952H214.345V169.544H212.745V163.992ZM210.425 168.008L200.985 168.872V161.208H206.441L206.905 156.968H200.985V155.624H208.649L207.913 162.552H202.585V167.384L210.425 166.664V168.008ZM230.073 163.336H217.369V155.336H229.913V156.68H218.969V161.992H230.073V163.336ZM230.905 169.112H216.377V167.768H230.905V169.112ZM244.745 163.992H241.321V162.648H244.745V159.752H241.321V158.408H244.745V154.952H246.345V169.544H244.745V163.992ZM242.425 168.008L232.985 168.872V161.208H238.441L238.905 156.968H232.985V155.624H240.649L239.913 162.552H234.585V167.384L242.425 166.664V168.008ZM258.201 163.4H253.081C250.729 163.4 249.065 161.624 249.065 159.336C249.065 157.032 250.729 155.256 253.081 155.256H258.201C260.553 155.256 262.217 157.032 262.217 159.336C262.217 161.624 260.553 163.4 258.201 163.4ZM253.257 162.056H258.025C259.529 162.056 260.617 160.936 260.617 159.336C260.617 157.736 259.529 156.6 258.025 156.6H253.257C251.769 156.6 250.665 157.736 250.665 159.336C250.665 160.936 251.769 162.056 253.257 162.056ZM262.905 169.112H248.377V167.768H252.025V164.12H253.625V167.768H257.689V164.12H259.289V167.768H262.905V169.112Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3346_410798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.191 206.859H66.5597C59.3772 206.859 53.5547 212.68 53.5547 219.86V387.169C53.5547 394.349 59.3772 400.17 66.5597 400.17H254.191C261.373 400.17 267.196 394.349 267.196 387.169V219.86C267.196 212.68 261.373 206.859 254.191 206.859Z",
    stroke: "#5F5F5F",
    strokeWidth: 1.55967,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.191 206.859H66.5597C59.3794 206.859 53.5547 212.682 53.5547 219.86V235.617H267.196V219.86C267.196 212.682 261.371 206.859 254.191 206.859Z",
    stroke: "#5F5F5F",
    strokeWidth: 1.55967,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5844 225.026C77.6806 225.026 79.3798 223.327 79.3798 221.232C79.3798 219.136 77.6806 217.438 75.5844 217.438C73.4883 217.438 71.7891 219.136 71.7891 221.232C71.7891 223.327 73.4883 225.026 75.5844 225.026Z",
    stroke: "#5F5F5F",
    strokeWidth: 1.55967,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.77 225.026C96.8661 225.026 98.5654 223.327 98.5654 221.232C98.5654 219.136 96.8661 217.438 94.77 217.438C92.6739 217.438 90.9746 219.136 90.9746 221.232C90.9746 223.327 92.6739 225.026 94.77 225.026Z",
    stroke: "#5F5F5F",
    strokeWidth: 1.55967,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.956 225.026C116.052 225.026 117.751 223.327 117.751 221.232C117.751 219.136 116.052 217.438 113.956 217.438C111.859 217.438 110.16 219.136 110.16 221.232C110.16 223.327 111.859 225.026 113.956 225.026Z",
    stroke: "#5F5F5F",
    strokeWidth: 1.55967,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.549 276.172H219.327C218.111 276.172 217.135 275.188 217.135 273.98C217.135 272.772 218.118 271.789 219.327 271.789H231.549C232.766 271.789 233.741 272.772 233.741 273.98C233.741 275.188 232.758 276.172 231.549 276.172Z",
    fill: "#8DC5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.992 288.945H219.327C218.111 288.945 217.135 287.962 217.135 286.754C217.135 285.546 218.118 284.562 219.327 284.562H239.992C241.208 284.562 242.184 285.546 242.184 286.754C242.184 287.962 241.201 288.945 239.992 288.945Z",
    fill: "#8DC5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.549 296.804H219.327C218.111 296.804 217.135 295.821 217.135 294.613C217.135 293.405 218.118 292.422 219.327 292.422H231.549C232.766 292.422 233.741 293.405 233.741 294.613C233.741 295.821 232.758 296.804 231.549 296.804Z",
    fill: "#8DC5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.72 392.791C224.051 392.791 226.39 391.955 228.249 390.259C232.215 386.651 232.502 380.519 228.892 376.554L182.922 326.078C179.312 322.114 173.178 321.827 169.212 325.435C165.246 329.044 164.96 335.176 168.569 339.14L214.54 389.617C216.453 391.723 219.079 392.783 221.72 392.783V392.791Z",
    fill: "#15416C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.75 353.991C184.225 353.991 191.095 344.801 191.095 333.464C191.095 322.128 184.225 312.938 175.75 312.938C167.276 312.938 160.406 322.128 160.406 333.464C160.406 344.801 167.276 353.991 175.75 353.991Z",
    fill: "#0F53B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.181 395.839C236.827 395.839 243.217 392.153 246.362 385.788L266.121 345.757C270.528 336.837 266.857 326.028 257.934 321.63C249.011 317.224 238.198 320.895 233.798 329.814L214.039 369.845C209.632 378.765 213.303 389.574 222.226 393.972C224.79 395.235 227.509 395.839 230.189 395.839H230.181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.151 321.754C258.074 321.715 258.004 321.669 257.927 321.63C249.004 317.224 238.191 320.895 233.791 329.814L214.032 369.845C211.406 375.157 211.669 381.127 214.171 386.028C214.249 386.067 214.318 386.113 214.396 386.152C216.96 387.414 219.678 388.018 222.358 388.018C229.004 388.018 235.394 384.333 238.539 377.968L258.298 337.937C260.924 332.625 260.661 326.655 258.159 321.754H258.151Z",
    fill: "#D2E6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.172 337.416C257.913 337.416 261.476 335.241 263.072 331.594L269.679 316.464C271.825 311.555 269.578 305.833 264.668 303.696C259.757 301.551 254.033 303.797 251.895 308.706L245.288 323.835C243.142 328.744 245.389 334.466 250.299 336.603C251.562 337.153 252.879 337.416 254.172 337.416Z",
    fill: "#0A2B4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.341 295.551C255.417 295.551 257.314 294.165 257.888 292.066L261.435 278.927L268.941 272.128C270.869 270.386 271.017 267.405 269.266 265.477C267.523 263.549 264.541 263.402 262.613 265.152L254.085 272.879C253.418 273.483 252.938 274.273 252.698 275.14L248.787 289.612C248.105 292.121 249.592 294.707 252.102 295.38C252.512 295.489 252.923 295.543 253.333 295.543L253.341 295.551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.46 319.231C248.852 316.194 243.52 305.932 246.559 296.328L251.155 281.799L271.435 288.21C279.455 290.746 283.909 299.316 281.372 307.334C278.334 316.938 268.068 322.269 258.46 319.231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.68 280.269L266.672 280.267C264.364 279.537 261.9 280.816 261.17 283.124L258.991 290.012C258.261 292.319 259.541 294.782 261.849 295.512L261.857 295.514C264.165 296.244 266.628 294.965 267.358 292.657L269.538 285.769C270.268 283.461 268.988 280.999 266.68 280.269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.894 284.121L273.887 284.118C271.578 283.389 269.115 284.668 268.385 286.975L266.206 293.863C265.476 296.171 266.755 298.633 269.064 299.363L269.071 299.366C271.38 300.095 273.843 298.816 274.573 296.509L276.752 289.621C277.483 287.313 276.203 284.851 273.894 284.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.586 287.949L280.578 287.946C278.27 287.217 275.807 288.496 275.076 290.804L272.897 297.691C272.167 299.999 273.447 302.462 275.755 303.191L275.763 303.194C278.071 303.924 280.535 302.644 281.265 300.337L283.444 293.449C284.174 291.141 282.894 288.679 280.586 287.949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.072 308.563C251.925 308.563 251.77 308.563 251.622 308.54C248.772 308.292 246.665 305.783 246.905 302.934L247.424 296.941C247.649 294.293 249.849 292.249 252.505 292.21L259.02 292.109C261.909 292.094 264.232 294.347 264.279 297.204C264.325 300.061 262.04 302.415 259.182 302.462L257.339 302.493L257.223 303.832C256.99 306.527 254.728 308.563 252.072 308.563Z",
    fill: "#3E495C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.804 300.652L117.977 312.057C115.94 320.257 119.983 328.829 127.008 331.206C135.544 334.295 144.498 325.948 143.917 315.588L143.413 303.734C142.523 288.511 124.591 286.266 120.812 300.652H120.804Z",
    fill: "#0A2B4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.084 272.323C165.084 257.124 152.466 244.805 136.905 244.805C121.344 244.805 108.727 257.124 108.727 272.323C108.727 273.043 108.765 273.748 108.82 274.452V276.303C109.571 292.308 116.565 302.064 125.38 307.979C142.196 319.253 163.504 308.343 165.084 287.29V274.452H164.991C165.045 273.748 165.084 273.043 165.084 272.323Z",
    fill: "#D2E6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.897 246.266C157.05 249.936 165.083 260.218 165.083 272.344C165.083 273.064 165.044 273.769 164.99 274.473H165.083V287.311C164.045 301.14 154.494 310.594 143.294 312.251C141.311 311.523 139.344 310.548 137.438 309.27C128.616 303.354 121.622 293.606 120.878 277.594V275.743C120.824 275.038 120.785 274.334 120.785 273.614C120.785 259.429 131.776 247.752 145.897 246.266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.738 280.165C120.738 286.344 117.082 291.354 112.566 291.354C108.05 291.354 104.395 286.344 104.395 280.165C104.395 273.986 108.05 268.977 112.566 268.977C117.082 268.977 120.738 273.986 120.738 280.165Z",
    fill: "#0A2B4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.098 287.217C112.939 287.217 115.241 284.063 115.241 280.171C115.241 276.28 112.939 273.125 110.098 273.125C107.258 273.125 104.955 276.28 104.955 280.171C104.955 284.063 107.258 287.217 110.098 287.217Z",
    fill: "#0F53B7",
    stroke: "white",
    strokeWidth: 0.955574,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.165 278.634C162.165 288.15 156.255 295.862 148.966 295.862C141.678 295.862 135.768 288.15 135.768 278.634C135.768 269.118 141.678 261.406 148.966 261.406C156.255 261.406 162.165 269.118 162.165 278.634Z",
    fill: "#0F53B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.173 278.633C159.173 285.369 154.99 290.835 149.832 290.835C144.673 290.835 140.49 285.369 140.49 278.633C140.49 271.896 144.673 266.43 149.832 266.43C154.99 266.43 159.173 271.896 159.173 278.633Z",
    fill: "#0A2B4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.835 288.303C153.92 288.303 157.232 283.977 157.232 278.64C157.232 273.303 153.92 268.977 149.835 268.977C145.749 268.977 142.438 273.303 142.438 278.64C142.438 283.977 145.749 288.303 149.835 288.303Z",
    fill: "#2EE7D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.02 282.279C154.646 282.279 156.775 279.495 156.775 276.061C156.775 272.627 154.646 269.844 152.02 269.844C149.393 269.844 147.264 272.627 147.264 276.061C147.264 279.495 149.393 282.279 152.02 282.279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.082 398.391H144.907C154.464 398.391 162.211 390.646 162.211 381.093V376.625C162.211 367.072 154.464 359.327 144.907 359.327H111.082C101.525 359.327 93.778 367.072 93.778 376.625V381.093C93.778 390.646 101.525 398.391 111.082 398.391Z",
    fill: "#15416C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.402 378.188H157.839C172.94 378.188 185.182 365.95 185.182 350.855V343.801C185.182 328.706 172.94 316.468 157.839 316.468H104.402C89.3014 316.468 77.0599 328.706 77.0599 343.801V350.855C77.0599 365.95 89.3014 378.188 104.402 378.188Z",
    fill: "#D2E6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.102 316.461H157.838C172.943 316.461 185.181 328.703 185.181 343.794V350.84C185.181 351.575 185.142 352.303 185.088 353.031C180.363 356.012 174.778 357.739 168.775 357.739H133.308C116.391 357.739 102.674 344.026 102.674 327.115V326.651C102.674 326.651 102.674 326.604 102.674 326.581C102.682 322.036 105.664 317.948 109.978 316.507L110.102 316.469V316.461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.154 353.223L54.9643 392.147C54.0581 390.258 53.5469 388.144 53.5469 385.914V360.091L63.7479 343.668C66.3892 339.418 71.9738 338.117 76.2262 340.757C80.4785 343.397 81.7798 348.98 79.1385 353.231L79.154 353.223Z",
    fill: "#15416C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.227 352.287C86.7013 352.287 93.5711 343.097 93.5711 331.761C93.5711 320.424 86.7013 311.234 78.227 311.234C69.7526 311.234 62.8828 320.424 62.8828 331.761C62.8828 343.097 69.7526 352.287 78.227 352.287Z",
    fill: "#0F53B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6378 341.912C74.8215 341.912 78.213 337.37 78.213 331.768C78.213 326.166 74.8215 321.625 70.6378 321.625C66.4541 321.625 63.0625 326.166 63.0625 331.768C63.0625 337.37 66.4541 341.912 70.6378 341.912Z",
    fill: "#0A2B4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.317 350.046H133.32C129.943 350.046 127.209 347.313 127.209 343.937C127.209 340.561 129.943 337.828 133.32 337.828H147.317C150.694 337.828 153.428 340.561 153.428 343.937C153.428 347.313 150.694 350.046 147.317 350.046Z",
    fill: "#0A2B4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.782 347.59H138.408C136.386 347.59 134.744 345.949 134.744 343.928C134.744 341.907 136.386 340.266 138.408 340.266H145.782C147.803 340.266 149.445 341.907 149.445 343.928C149.445 345.949 147.803 347.59 145.782 347.59Z",
    fill: "#2EE7D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.844 294.242C292.802 294.242 288.705 290.146 288.705 285.106V284.409H306.984V285.106C306.984 290.146 302.887 294.242 297.844 294.242Z",
    fill: "#0A2B4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.738 294.062C295.602 293.187 292.496 289.517 292.496 285.127V284.43H306.988V285.127C306.988 289.525 303.882 293.195 299.746 294.062H299.738Z",
    fill: "#0F53B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.51 285.023H306.264C307.273 285.023 308.092 284.205 308.092 283.196C308.092 282.187 307.273 281.369 306.264 281.369H289.51C288.5 281.369 287.682 282.187 287.682 283.196C287.682 284.205 288.5 285.023 289.51 285.023Z",
    fill: "#8AC0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.682 250.558C274.682 237.774 285.045 227.406 297.841 227.406C310.629 227.406 321.001 237.766 321.001 250.558C321.001 258.796 316.686 266.028 310.203 270.132L306.989 281.382H288.701L285.487 270.132C279.004 266.028 274.689 258.804 274.689 250.558H274.682Z",
    fill: "#F6E08E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.654 250.558C274.654 258.796 278.969 266.028 285.452 270.124L288.666 281.375H294.444L291.23 270.124C284.747 266.02 280.433 258.796 280.433 250.558C280.433 238.75 289.27 229.009 300.703 227.592C299.758 227.468 298.79 227.406 297.814 227.406C285.026 227.406 274.654 237.766 274.654 250.55V250.558Z",
    fill: "#F9A53F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.017 254.13C319.869 251.595 319.773 244.653 315.804 238.623C311.834 232.593 305.493 229.76 301.641 232.294C297.789 234.828 297.884 241.771 301.854 247.801C305.824 253.83 312.164 256.664 316.017 254.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.521 373.901H131.649V361.788H133.521V373.901ZM127.55 372.833L122.331 373.413V362.276H129.356V373.413H127.55V372.833ZM124.15 363.844V371.621L127.55 371.252V363.844H124.15ZM135.485 368.761V367.153C138.147 366.968 140.164 365.017 140.164 363.317V361.92H142.035V363.317C142.035 365.017 144.065 366.968 146.714 367.153V368.761C144.052 368.681 141.93 367.311 141.1 365.689C140.269 367.311 138.147 368.681 135.485 368.761ZM147.11 373.611H135.089V371.963H147.11V373.611ZM159.078 370.869H157.246L157.733 363.647H148.902V362.052H159.658L159.078 370.869ZM160.29 373.611H148.27V371.99H152.54V366.836H154.359V371.99H160.29V373.611Z",
    fill: "#0A2B4C"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3346_410798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334 361L330.417 391.289L323.891 384.949L231.17 496.695L203.479 463.402L131.462 556.25L102.607 526.298L50.8657 595L14 550.342L22.6374 537.3L50.2771 570.784L101.583 502.654L130.995 533.228L203.402 439.911L231.087 473.198L313.046 374.423L306.29 367.861L334 361Z",
    fill: "#FF6460"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_3346_410798)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M322.269 829.88H280.152V618.248L322.269 604.094V829.88Z",
    fill: "#4B6FA2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M322.27 829.88L364.381 839.77V613.984L322.27 604.094V829.88Z",
    fill: "#81ACDF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M350.429 619.626L327.309 614.196V611.93L350.429 617.36V619.626Z",
    fill: "#A5C2EC"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M350.429 624.889L327.309 619.459V617.188L350.429 622.623V624.889Z",
    fill: "#A5C2EC"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M350.429 630.163L327.309 624.733V622.461L350.429 627.897V630.163Z",
    fill: "#A5C2EC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M350.429 635.428L327.309 629.998V627.727L350.429 633.157V635.428Z",
    fill: "#A5C2EC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M350.429 640.702L327.309 635.272V633L350.429 638.43V640.702Z",
    fill: "#A5C2EC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M350.429 645.967L327.309 640.538V638.266L350.429 643.696V645.967Z",
    fill: "#A5C2EC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M350.429 651.241L327.309 645.811V643.539L350.429 648.969V651.241Z",
    fill: "#A5C2EC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M350.429 656.507L327.309 651.077V648.805L350.429 654.235V656.507Z",
    fill: "#A5C2EC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M350.429 661.78L327.309 656.35V654.078L350.429 659.508V661.78Z",
    fill: "#A5C2EC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M350.429 667.046L327.309 661.616V659.344L350.429 664.774V667.046Z",
    fill: "#A5C2EC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M350.429 672.319L327.309 666.883V664.617L350.429 670.047V672.319Z",
    fill: "#A5C2EC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M350.429 677.585L327.309 672.149V669.883L350.429 675.313V677.585Z",
    fill: "#A5C2EC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M350.429 682.852L327.309 677.422V675.156L350.429 680.586V682.852Z",
    fill: "#A5C2EC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M257.536 832.816H216.346V625.83L257.536 611.984V832.816Z",
    fill: "#4B6FA2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M257.537 832.816L298.727 842.492V621.661L257.537 611.984V832.816Z",
    fill: "#6183BB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M257.537 832.639H208.01V641.615L257.537 624.969V832.639Z",
    fill: "#6183BB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M257.537 832.08L307.064 843.713V636.608L257.537 624.969V832.08Z",
    fill: "#81ACDF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3346_410798",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 257,
    y: 624,
    width: 51,
    height: 220
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M257.537 832.08L307.064 843.713V636.608L257.537 624.969V832.08Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3346_410798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.189 623.141V894.894",
    stroke: "#A5C2EC",
    strokeWidth: 0.78,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.48 624.898V896.652",
    stroke: "#A5C2EC",
    strokeWidth: 0.78,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.77 626.648V898.396",
    stroke: "#A5C2EC",
    strokeWidth: 0.78,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.059 628.398V900.152",
    stroke: "#A5C2EC",
    strokeWidth: 0.78,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.348 630.156V901.903",
    stroke: "#A5C2EC",
    strokeWidth: 0.78,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.5 637.984L311.599 651.788",
    stroke: "#A5C2EC",
    strokeWidth: 0.78,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.5 653.023L311.599 666.833",
    stroke: "#A5C2EC",
    strokeWidth: 0.78,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.5 668.07L311.599 681.88",
    stroke: "#A5C2EC",
    strokeWidth: 0.78,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.5 683.117L311.599 696.927",
    stroke: "#A5C2EC",
    strokeWidth: 0.78,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.5 698.164L311.599 711.974",
    stroke: "#A5C2EC",
    strokeWidth: 0.78,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.5 713.211L311.599 727.021",
    stroke: "#A5C2EC",
    strokeWidth: 0.78,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.5 728.25L311.599 742.06",
    stroke: "#A5C2EC",
    strokeWidth: 0.78,
    strokeMiterlimit: 10
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M182.842 788.997H140.73V577.366L182.842 563.211V788.997Z",
    fill: "#6183BB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M182.842 788.997L224.959 798.887V573.107L182.842 563.211V788.997Z",
    fill: "#81ACDF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M189.021 584.005L193.401 585.028V576.88L189.021 575.852V584.005Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M195.201 585.32L199.575 586.349V578.201L195.201 577.172V585.32Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M201.375 586.632L205.754 587.661V579.513L201.375 578.484V586.632Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M189.021 595.445L193.401 596.474V588.326L189.021 587.297V595.445Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M195.201 596.757L199.575 597.786V589.638L195.201 588.609V596.757Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M201.375 598.078L205.754 599.106V590.959L201.375 589.93V598.078Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M189.021 606.882L193.401 607.911V599.763L189.021 598.734V606.882Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M195.201 608.195L199.575 609.224V601.076L195.201 600.047V608.195Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M201.375 609.507L205.754 610.536V602.388L201.375 601.359V609.507Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M189.021 618.326L193.401 619.349V611.201L189.021 610.172V618.326Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M195.201 619.638L199.575 620.661V612.513L195.201 611.484V619.638Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M201.375 620.945L205.754 621.974V613.826L201.375 612.797V620.945Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M109.254 847.746H60.6719V603.63L109.254 587.305V847.746Z",
    fill: "#6183BB"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M109.254 847.746L171.467 860.402V601.561L109.254 587.305V847.746Z",
    fill: "#81ACDF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M116.859 613.466L163.914 624.243L163.855 611.2L116.859 600.43V613.466Z",
    fill: "#6183BB"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M163.861 631.852L116.859 655.617V658.46L163.867 634.659L163.861 631.852Z",
    fill: "#A5C2EC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M116.859 615.594V642.797L153.848 624.069L116.859 615.594Z",
    fill: "#A5C2EC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M116.859 661.188V673.82L163.879 650.007L163.867 637.422L116.859 661.188Z",
    fill: "#A5C2EC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M163.914 687L163.891 662.859L131.043 679.47L163.914 687Z",
    fill: "#A5C2EC"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M163.855 626.36L153.848 624.07L116.859 642.799V655.621L163.861 631.855L163.855 626.36Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M116.859 676.224L131.043 679.471L163.891 662.86L163.879 650.008L116.859 673.821V676.224Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M163.867 634.664L116.859 658.465V661.189L163.867 637.424V634.664Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M134.863 681.477H133.473V618.203L134.863 618.822V681.477Z",
    fill: "#81ACDF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M151.08 622.227H149.689V685.602H151.08V622.227Z",
    fill: "#81ACDF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6171 731.786H-4.5V520.155L37.6171 506V731.786Z",
    fill: "#6183BB"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6172 731.786L79.7283 741.676V515.89L37.6172 506V731.786Z",
    fill: "#81ACDF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6838 525.63L42.6562 518.106V513.836L74.6838 521.359V525.63Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6838 534.378L42.6562 526.854V522.578L74.6838 530.102V534.378Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6838 543.13L42.6562 535.606V531.336L74.6838 538.859V543.13Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6838 551.886L42.6562 544.362V540.086L74.6838 547.609V551.886Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6838 560.63L42.6562 553.106V548.836L74.6838 556.359V560.63Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6838 569.386L42.6562 561.862V557.586L74.6838 565.109V569.386Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6838 578.137L42.6562 570.614V566.344L74.6838 573.867V578.137Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6838 586.893L42.6562 579.37V575.094L74.6838 582.617V586.893Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6838 595.637L42.6562 588.114V583.844L74.6838 591.367V595.637Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6838 604.393L42.6562 596.87V592.594L74.6838 600.117V604.393Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6838 613.137L42.6562 605.614V601.344L74.6838 608.867V613.137Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6838 621.893L42.6562 614.37V610.094L74.6838 617.623V621.893Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6838 630.645L42.6562 623.122V618.852L74.6838 626.375V630.645Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6838 639.403L42.6562 631.88V627.609L74.6838 635.133V639.403Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6838 648.145L42.6562 640.622V636.352L74.6838 643.875V648.145Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6838 656.903L42.6562 649.38V645.109L74.6838 652.633V656.903Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M293.611 729.523V733.665C293.611 735.958 298.797 737.817 305.191 737.817C311.585 737.817 316.771 735.958 316.771 733.665V729.523H293.611Z",
    fill: "#BCBCBC"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M293.611 729.527C293.611 731.81 298.797 733.669 305.191 733.669C311.585 733.669 316.771 731.81 316.771 729.527C316.771 727.244 311.59 725.375 305.191 725.375C298.792 725.375 293.611 727.228 293.611 729.527Z",
    fill: "#DBDBDB"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M292.332 724.281V728.423C292.332 730.716 297.518 732.575 303.912 732.575C310.306 732.575 315.486 730.716 315.486 728.423V724.281H292.332Z",
    fill: "#BCBCBC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3346_410798",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 292,
    y: 724,
    width: 24,
    height: 9
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M292.332 724.281V728.423C292.332 730.716 297.518 732.575 303.912 732.575C310.306 732.575 315.486 730.716 315.486 728.423V724.281H292.332Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3346_410798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.555 725.516H314.1V731.532H314.555V725.516Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.971 726.062H312.516V732.079H312.971V726.062Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.383 726.602H310.934V732.618H311.383V726.602Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.801 727.141H309.352V733.162H309.801V727.141Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.225 727.68H307.77V733.696H308.225V727.68Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.637 727.617H306.188V733.633H306.637V727.617Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.481 725.516H295.031V731.532H295.481V725.516Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.899 725.312H293.449V731.329H293.899V725.312Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.063 726.055H296.613V732.071H297.063V726.055Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.645 726.594H298.195V732.61H298.645V726.594Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.233 727.133H299.777V733.154H300.233V727.133Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.811 727.672H301.361V733.688H301.811V727.672Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.397 727.609H302.947V733.625H303.397V727.609Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.057 727.609H304.602V733.625H305.057V727.609Z",
    fill: "#AAAAAA"
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M292.332 724.285C292.332 726.568 297.518 728.426 303.912 728.426C310.306 728.426 315.486 726.568 315.486 724.285C315.486 722.002 310.306 720.133 303.912 720.133C297.518 720.133 292.332 721.986 292.332 724.285Z",
    fill: "#DBDBDB"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M293.678 718.391V722.532C293.678 724.826 298.863 726.684 305.252 726.684C311.641 726.684 316.832 724.826 316.832 722.532V718.391H293.678Z",
    fill: "#BCBCBC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3346_410798",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 293,
    y: 718,
    width: 24,
    height: 9
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M293.678 718.391V722.532C293.678 724.826 298.863 726.684 305.252 726.684C311.641 726.684 316.832 724.826 316.832 722.532V718.391H293.678Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3346_410798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.9 719.617H315.445V725.639H315.9V719.617Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.311 720.156H313.861V726.172H314.311V720.156Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.734 720.703H312.279V726.719H312.734V720.703Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.152 721.242H310.697V727.258H311.152V721.242Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.559 721.781H309.109V727.803H309.559V721.781Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.977 721.719H307.527V727.74H307.977V721.719Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.827 719.625H296.377V725.646H296.827V719.625Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.245 719.422H294.795V725.443H295.245V719.422Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.409 720.164H297.959V726.18H298.409V720.164Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.993 720.703H299.543V726.719H299.993V720.703Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.573 721.25H301.123V727.266H301.573V721.25Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.157 721.781H302.707V727.803H303.157V721.781Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.744 721.719H304.289V727.74H304.744V721.719Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.397 721.719H305.947V727.74H306.397V721.719Z",
    fill: "#AAAAAA"
  }))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M293.678 718.394C293.678 720.677 298.863 722.536 305.252 722.536C311.641 722.536 316.832 720.677 316.832 718.394C316.832 716.111 311.651 714.242 305.252 714.242C298.853 714.242 293.678 716.095 293.678 718.394Z",
    fill: "#DBDBDB"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M295.773 718.395C295.773 720.071 300.022 721.44 305.256 721.44C310.49 721.44 314.739 720.076 314.739 718.395C314.739 716.713 310.496 715.344 305.256 715.344C300.016 715.344 295.773 716.708 295.773 718.395Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M291 711.844V715.985C291 718.273 296.186 720.137 302.58 720.137C308.974 720.137 314.154 718.279 314.154 715.985V711.844H291Z",
    fill: "#BCBCBC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3346_410798",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 291,
    y: 711,
    width: 24,
    height: 10
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M291 711.844V715.985C291 718.273 296.186 720.137 302.58 720.137C308.974 720.137 314.154 718.279 314.154 715.985V711.844H291Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3346_410798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.219 713.07H312.77V719.092H313.219V713.07Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.641 713.609H311.186V719.625H311.641V713.609Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.053 714.148H309.604V720.17H310.053V714.148Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.471 714.695H308.016V720.711H308.471V714.695Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.883 715.234H306.434V721.25H306.883V715.234Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.307 715.164H304.852V721.18H305.307V715.164Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.154 713.07H293.699V719.092H294.154V713.07Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.567 712.867H292.117V718.889H292.567V712.867Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.736 713.617H295.281V719.633H295.736V713.617Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.318 714.148H296.863V720.17H297.318V714.148Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.895 714.695H298.445V720.711H298.895V714.695Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.479 715.234H300.029V721.25H300.479V715.234Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.065 715.164H301.609V721.18H302.065V715.164Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.719 715.164H303.27V721.18H303.719V715.164Z",
    fill: "#AAAAAA"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M291 711.847C291 714.13 296.186 715.989 302.58 715.989C308.974 715.989 314.154 714.13 314.154 711.847C314.154 709.565 308.974 707.695 302.58 707.695C296.186 707.695 291 709.548 291 711.847Z",
    fill: "#DBDBDB"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M293.098 711.848C293.098 713.524 297.346 714.893 302.58 714.893C307.815 714.893 312.063 713.529 312.063 711.848C312.063 710.167 307.82 708.797 302.58 708.797C297.34 708.797 293.098 710.161 293.098 711.848Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M335.177 663.375L337.068 667.13C338.114 669.208 334.375 672.85 328.718 675.262C323.056 677.674 317.626 677.942 316.581 675.858L314.689 672.104L335.177 663.375Z",
    fill: "#DFB747"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_3346_410798",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 314,
    y: 663,
    width: 24,
    height: 15
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M335.177 663.375L337.068 667.13C338.114 669.208 334.375 672.85 328.718 675.262C323.056 677.674 317.626 677.942 316.581 675.858L314.689 672.104L335.177 663.375Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_3346_410798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.224 678.158L318.823 678.325L316.076 672.867L316.477 672.695L319.224 678.158Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.871 678.057L320.47 678.228L317.723 672.766L318.124 672.594L320.871 678.057Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.519 677.947L322.118 678.119L319.371 672.656L319.772 672.484L322.519 677.947Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.166 677.846L323.765 678.012L321.018 672.555L321.419 672.383L324.166 677.846Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.814 677.736L325.419 677.908L322.666 672.445L323.067 672.273L325.814 677.736Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.185 677.08L326.784 677.246L324.037 671.789L324.438 671.617L327.185 677.08Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.696 671.137L336.097 670.971L333.35 665.508L332.949 665.68L335.696 671.137Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.009 670.361L337.41 670.189L334.657 664.727L334.256 664.898L337.009 670.361Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.542 672.228L334.943 672.057L332.196 666.594L331.795 666.766L334.542 672.228Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.388 673.317L333.789 673.145L331.042 667.688L330.641 667.854L333.388 673.317Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.241 674.408L332.637 674.236L329.889 668.773L329.488 668.945L332.241 674.408Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.085 675.489L331.481 675.317L328.733 669.859L328.338 670.031L331.085 675.489Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.655 676.025L330.051 675.853L327.303 670.391L326.902 670.563L329.655 676.025Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.588 676.481L328.187 676.653L325.439 671.195L325.835 671.023L328.588 676.481Z",
    fill: "#D89F3A"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M335.178 663.372C336.224 665.446 332.48 669.087 326.823 671.494C321.16 673.906 315.731 674.174 314.685 672.101C313.634 670.017 317.372 666.38 323.03 663.968C328.687 661.557 334.121 661.288 335.173 663.372H335.178Z",
    fill: "#FFDC85"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M333.321 664.166C334.085 665.691 330.953 668.527 326.32 670.504C321.682 672.481 317.309 672.841 316.539 671.315C315.765 669.784 318.902 666.948 323.535 664.971C328.168 663 332.546 662.635 333.321 664.166Z",
    fill: "#FFF39F"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M339.584 651.317L338.446 655.335C337.817 657.558 332.464 658.063 326.487 656.463C320.51 654.862 316.186 651.763 316.815 649.533L317.953 645.516L339.584 651.317Z",
    fill: "#DFB747"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_3346_410798",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 316,
    y: 645,
    width: 24,
    height: 13
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M339.584 651.317L338.446 655.335C337.817 657.558 332.464 658.063 326.487 656.463C320.51 654.862 316.186 651.763 316.815 649.533L317.953 645.516L339.584 651.317Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_3346_410798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.259 652.902L316.836 652.789L318.489 646.945L318.911 647.063L317.259 652.902Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.592 653.819L318.164 653.706L319.822 647.867L320.245 647.98L318.592 653.819Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.919 654.748L319.496 654.636L321.149 648.797L321.571 648.91L319.919 654.748Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.247 655.663L320.824 655.55L322.482 649.711L322.9 649.824L321.247 655.663Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.579 656.584L322.156 656.472L323.809 650.633L324.232 650.746L322.579 656.584Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.075 656.913L323.652 656.8L325.305 650.961L325.728 651.079L324.075 656.913Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.652 657.565L335.075 657.678L336.728 651.839L336.305 651.727L334.652 657.565Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.186 657.761L336.608 657.873L338.261 652.035L337.838 651.922L336.186 657.761Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.021 657.698L333.444 657.811L335.102 651.972L334.68 651.859L333.021 657.698Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.395 657.823L331.817 657.936L333.47 652.097L333.047 651.984L331.395 657.823Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.77 657.948L330.192 658.061L331.845 652.222L331.422 652.109L329.77 657.948Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.141 658.073L328.563 658.191L330.221 652.353L329.799 652.234L328.141 658.073Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.682 657.618L327.104 657.73L328.757 651.892L328.334 651.773L326.682 657.618Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.555 657.311L325.133 657.198L326.785 651.359L327.208 651.472L325.555 657.311Z",
    fill: "#D89F3A"
  }))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M339.582 651.315C338.954 653.528 333.6 654.033 327.629 652.432C321.652 650.831 317.323 647.732 317.951 645.513C318.58 643.284 323.928 642.779 329.905 644.38C335.876 645.981 340.211 649.08 339.577 651.309L339.582 651.315Z",
    fill: "#FFDC85"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M337.628 650.789C337.168 652.422 332.822 652.68 327.934 651.369C323.041 650.053 319.454 647.668 319.915 646.041C320.381 644.402 324.716 644.139 329.609 645.455C334.502 646.766 338.094 649.151 337.628 650.789Z",
    fill: "#FFF39F"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M333.628 730.746C333.628 733.029 328.443 734.887 322.049 734.887C315.655 734.887 310.475 733.029 310.475 730.746C310.475 728.463 315.655 726.594 322.049 726.594C328.443 726.594 333.628 728.447 333.628 730.746Z",
    fill: "#FFDC85"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M333.06 725.359V729.501C333.06 731.789 327.874 733.653 321.48 733.653C315.086 733.653 309.906 731.794 309.906 729.501V725.359H333.06Z",
    fill: "#DFB747"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_3346_410798",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 309,
    y: 725,
    width: 25,
    height: 9
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M333.06 725.359V729.501C333.06 731.789 327.874 733.653 321.48 733.653C315.086 733.653 309.906 731.794 309.906 729.501V725.359H333.06Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_3346_410798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.293 726.594H310.838V732.61H311.293V726.594Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.87 727.141H312.42V733.157H312.87V727.141Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.452 727.68H314.002V733.701H314.452V727.68Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.041 728.219H315.586V734.24H316.041V728.219Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.616 728.758H317.166V734.774H317.616V728.758Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.2 728.695H318.75V734.711H319.2V728.695Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.356 726.594H329.906V732.61H330.356V726.594Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.938 726.391H331.488V732.407H331.938V726.391Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.779 727.133H328.324V733.149H328.779V727.133Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.192 727.672H326.742V733.693H327.192V727.672Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.61 728.219H325.16V734.24H325.61V728.219Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.033 728.758H323.578V734.774H324.033V728.758Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.445 728.688H321.99V734.704H322.445V728.688Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.786 728.688H320.336V734.704H320.786V728.688Z",
    fill: "#D89F3A"
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M333.06 725.363C333.06 727.646 327.874 729.504 321.48 729.504C315.086 729.504 309.906 727.646 309.906 725.363C309.906 723.08 315.086 721.211 321.48 721.211C327.874 721.211 333.06 723.064 333.06 725.363Z",
    fill: "#FFDC85"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M333.325 720.039V724.18C333.325 726.474 328.14 728.333 321.746 728.333C315.352 728.333 310.166 726.474 310.166 724.18V720.039H333.32H333.325Z",
    fill: "#DFB747"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_3346_410798",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 310,
    y: 720,
    width: 24,
    height: 9
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M333.325 720.039V724.18C333.325 726.474 328.14 728.333 321.746 728.333C315.352 728.333 310.166 726.474 310.166 724.18V720.039H333.32H333.325Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_3346_410798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.559 721.273H311.104V727.295H311.559V721.273Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.135 721.812H312.686V727.829H313.135V721.812Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.717 722.352H314.268V728.368H314.717V722.352Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.301 722.898H315.852V728.92H316.301V722.898Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.887 723.438H317.432V729.454H317.887V723.438Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.469 723.367H319.02V729.383H319.469V723.367Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.629 721.273H330.174V727.295H330.629V721.273Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.209 721.07H331.754V727.086H332.209V721.07Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.045 721.812H328.59V727.829H329.045V721.812Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.458 722.352H327.008V728.368H327.458V722.352Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.876 722.898H325.426V728.92H325.876V722.898Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.293 723.438H323.844V729.454H324.293V723.438Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.711 723.367H322.262V729.383H322.711V723.367Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.057 723.367H320.602V729.383H321.057V723.367Z",
    fill: "#D89F3A"
  }))), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M333.325 720.043C333.325 722.331 328.14 724.184 321.746 724.184C315.352 724.184 310.166 722.326 310.166 720.043C310.166 717.76 315.346 715.891 321.746 715.891C328.145 715.891 333.325 717.744 333.325 720.043Z",
    fill: "#FFDC85"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M335.052 714.438V718.579C335.052 720.867 329.867 722.731 323.473 722.731C317.079 722.731 311.898 720.873 311.898 718.579V714.438H335.052Z",
    fill: "#DFB747"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_3346_410798",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 311,
    y: 714,
    width: 25,
    height: 9
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M335.052 714.438V718.579C335.052 720.867 329.867 722.731 323.473 722.731C317.079 722.731 311.898 720.873 311.898 718.579V714.438H335.052Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_3346_410798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.28 715.664H312.83V721.685H313.28V715.664Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.867 716.203H314.412V722.219H314.867V716.203Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.444 716.75H315.994V722.771H316.444V716.75Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.028 717.289H317.578V723.31H318.028V717.289Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.613 717.828H319.158V723.844H319.613V717.828Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.201 717.758H320.746V723.779H321.201V717.758Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.356 715.664H331.9V721.685H332.356V715.664Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.93 715.461H333.48V721.477H333.93V715.461Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.766 716.211H330.316V722.227H330.766V716.211Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.19 716.75H328.734V722.771H329.19V716.75Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.602 717.289H327.152V723.31H327.602V717.289Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.02 717.828H325.57V723.844H326.02V717.828Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.438 717.758H323.988V723.779H324.438V717.758Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.783 717.758H322.328V723.779H322.783V717.758Z",
    fill: "#D89F3A"
  }))), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M335.052 714.441C335.052 716.724 329.867 718.583 323.473 718.583C317.079 718.583 311.898 716.724 311.898 714.441C311.898 712.158 317.079 710.289 323.473 710.289C329.867 710.289 335.052 712.142 335.052 714.441Z",
    fill: "#FFDC85"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M335.052 709.023V713.165C335.052 715.453 329.867 717.312 323.473 717.312C317.079 717.312 311.898 715.453 311.898 713.165V709.023H335.052Z",
    fill: "#DFB747"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_3346_410798",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 311,
    y: 709,
    width: 25,
    height: 9
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M335.052 709.023V713.165C335.052 715.453 329.867 717.312 323.473 717.312C317.079 717.312 311.898 715.453 311.898 713.165V709.023H335.052Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_3346_410798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.28 710.258H312.83V716.274H313.28V710.258Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.867 710.797H314.412V716.818H314.867V710.797Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.444 711.336H315.994V717.357H316.444V711.336Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.028 711.883H317.578V717.899H318.028V711.883Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.613 712.422H319.158V718.443H319.613V712.422Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.201 712.352H320.746V718.373H321.201V712.352Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.356 710.258H331.9V716.274H332.356V710.258Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.93 710.055H333.48V716.071H333.93V710.055Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.766 710.797H330.316V716.818H330.766V710.797Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.19 711.336H328.734V717.357H329.19V711.336Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.602 711.883H327.152V717.899H327.602V711.883Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.02 712.422H325.57V718.443H326.02V712.422Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.438 712.352H323.988V718.373H324.438V712.352Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.783 712.352H322.328V718.373H322.783V712.352Z",
    fill: "#D89F3A"
  }))), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M335.052 709.027C335.052 711.31 329.867 713.169 323.473 713.169C317.079 713.169 311.898 711.31 311.898 709.027C311.898 706.744 317.079 704.875 323.473 704.875C329.867 704.875 335.052 706.728 335.052 709.027Z",
    fill: "#FFDC85"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M336.332 703.781V707.923C336.332 710.216 331.146 712.075 324.752 712.075C318.358 712.075 313.178 710.216 313.178 707.923V703.781H336.332Z",
    fill: "#DFB747"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_3346_410798",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 313,
    y: 703,
    width: 24,
    height: 10
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M336.332 703.781V707.923C336.332 710.216 331.146 712.075 324.752 712.075C318.358 712.075 313.178 710.216 313.178 707.923V703.781H336.332Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_3346_410798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.559 705.008H314.109V711.024H314.559V705.008Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.147 705.547H315.697V711.568H316.147V705.547Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.729 706.094H317.279V712.11H317.729V706.094Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.311 706.633H318.861V712.654H319.311V706.633Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.893 707.172H320.443V713.188H320.893V707.172Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.477 707.109H322.027V713.131H322.477V707.109Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.633 705.008H333.184V711.024H333.633V705.008Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.213 704.805H334.758V710.821H335.213V704.805Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.049 705.547H331.6V711.568H332.049V705.547Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.461 706.094H330.012V712.11H330.461V706.094Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.879 706.633H328.43V712.654H328.879V706.633Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.297 707.172H326.848V713.188H327.297V707.172Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.715 707.109H325.266V713.131H325.715V707.109Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.057 707.109H323.607V713.131H324.057V707.109Z",
    fill: "#D89F3A"
  }))), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M336.332 703.785C336.332 706.068 331.146 707.926 324.752 707.926C318.358 707.926 313.178 706.068 313.178 703.785C313.178 701.502 318.358 699.633 324.752 699.633C331.146 699.633 336.332 701.486 336.332 703.785Z",
    fill: "#FFDC85"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M334.988 697.891V702.032C334.988 704.32 329.802 706.184 323.408 706.184C317.014 706.184 311.834 704.326 311.834 702.032V697.891H334.988Z",
    fill: "#DFB747"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_3346_410798",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 311,
    y: 697,
    width: 24,
    height: 10
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M334.988 697.891V702.032C334.988 704.32 329.802 706.184 323.408 706.184C317.014 706.184 311.834 704.326 311.834 702.032V697.891H334.988Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_3346_410798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.227 699.125H312.771V705.141H313.227V699.125Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.803 699.664H314.354V705.68H314.803V699.664Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.391 700.203H315.936V706.219H316.391V700.203Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.969 700.75H317.52V706.771H317.969V700.75Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.549 701.281H319.1V707.297H319.549V701.281Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.133 701.219H320.684V707.24H321.133V701.219Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.29 699.125H331.84V705.141H332.29V699.125Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.872 698.922H333.422V704.943H333.872V698.922Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.713 699.664H330.258V705.68H330.713V699.664Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.131 700.203H328.676V706.219H329.131V700.203Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.543 700.75H327.088V706.771H327.543V700.75Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.956 701.289H325.506V707.305H325.956V701.289Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.374 701.219H323.924V707.24H324.374V701.219Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.715 701.219H322.266V707.24H322.715V701.219Z",
    fill: "#D89F3A"
  }))), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M334.988 697.894C334.988 700.177 329.802 702.036 323.408 702.036C317.014 702.036 311.834 700.177 311.834 697.894C311.834 695.611 317.014 693.742 323.408 693.742C329.802 693.742 334.988 695.595 334.988 697.894Z",
    fill: "#FFDC85"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M332.891 697.895C332.891 699.576 328.643 700.94 323.408 700.94C318.174 700.94 313.926 699.576 313.926 697.895C313.926 696.213 318.169 694.844 323.408 694.844C328.648 694.844 332.891 696.208 332.891 697.895Z",
    fill: "#FFF39F"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M351.142 731.59C351.142 733.873 345.956 735.731 339.562 735.731C333.168 735.731 327.988 733.873 327.988 731.59C327.988 729.307 333.168 727.438 339.562 727.438C345.956 727.438 351.142 729.291 351.142 731.59Z",
    fill: "#FFDC85"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M349.615 727.023V731.165C349.615 733.453 344.429 735.312 338.035 735.312C331.641 735.312 326.461 733.453 326.461 731.165V727.023H349.615Z",
    fill: "#DFB747"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_3346_410798",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 326,
    y: 727,
    width: 24,
    height: 9
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M349.615 727.023V731.165C349.615 733.453 344.429 735.312 338.035 735.312C331.641 735.312 326.461 733.453 326.461 731.165V727.023H349.615Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_3346_410798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.848 728.258H327.393V734.274H327.848V728.258Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.43 728.797H328.975V734.813H329.43V728.797Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.012 729.336H330.562V735.357H331.012V729.336Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.596 729.883H332.141V735.899H332.596V729.883Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.918 728.258H346.463V734.274H346.918V728.258Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.493 728.055H348.043V734.076H348.493V728.055Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.329 728.797H344.879V734.813H345.329V728.797Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.747 729.336H343.297V735.357H343.747V729.336Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.165 729.883H341.715V735.899H342.165V729.883Z",
    fill: "#D89F3A"
  }))), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M349.615 727.027C349.615 729.31 344.429 731.169 338.035 731.169C331.641 731.169 326.461 729.31 326.461 727.027C326.461 724.744 331.641 722.875 338.035 722.875C344.429 722.875 349.615 724.728 349.615 727.027Z",
    fill: "#FFDC85"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M349.615 721.609V725.751C349.615 728.039 344.429 729.898 338.035 729.898C331.641 729.898 326.461 728.039 326.461 725.751V721.609H349.615Z",
    fill: "#DFB747"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_3346_410798",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 326,
    y: 721,
    width: 24,
    height: 9
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M349.615 721.609V725.751C349.615 728.039 344.429 729.898 338.035 729.898C331.641 729.898 326.461 728.039 326.461 725.751V721.609H349.615Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_3346_410798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.848 722.844H327.393V728.865H327.848V722.844Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.43 723.391H328.975V729.412H329.43V723.391Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.012 723.93H330.562V729.946H331.012V723.93Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.596 724.469H332.141V730.49H332.596V724.469Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.182 725.008H333.727V731.029H334.182V725.008Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.758 724.945H335.309V730.961H335.758V724.945Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.918 722.844H346.463V728.865H346.918V722.844Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.493 722.641H348.043V728.657H348.493V722.641Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.329 723.383H344.879V729.404H345.329V723.383Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.747 723.922H343.297V729.938H343.747V723.922Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.165 724.469H341.715V730.49H342.165V724.469Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.588 725.008H340.133V731.029H340.588V725.008Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.001 724.938H338.551V730.954H339.001V724.938Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.34 724.938H336.891V730.954H337.34V724.938Z",
    fill: "#D89F3A"
  }))), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M349.615 721.613C349.615 723.896 344.429 725.754 338.035 725.754C331.641 725.754 326.461 723.896 326.461 721.613C326.461 719.33 331.641 717.461 338.035 717.461C344.429 717.461 349.615 719.314 349.615 721.613Z",
    fill: "#FFDC85"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M351.57 716.617V720.759C351.57 723.047 346.384 724.905 339.99 724.905C333.596 724.905 328.416 723.047 328.416 720.759V716.617H351.57Z",
    fill: "#DFB747"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_3346_410798",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 328,
    y: 716,
    width: 24,
    height: 9
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M351.57 716.617V720.759C351.57 723.047 346.384 724.905 339.99 724.905C333.596 724.905 328.416 723.047 328.416 720.759V716.617H351.57Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_3346_410798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.803 717.844H329.354V723.865H329.803V717.844Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.391 718.391H330.936V724.407H331.391V718.391Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.967 718.93H332.518V724.951H332.967V718.93Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.557 719.469H334.102V725.485H334.557V719.469Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.131 720.008H335.682V726.024H336.131V720.008Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.715 719.945H337.266V725.967H337.715V719.945Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.872 717.844H348.422V723.865H348.872V717.844Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.454 717.648H350.004V723.664H350.454V717.648Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.295 718.391H346.84V724.407H347.295V718.391Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.708 718.93H345.258V724.951H345.708V718.93Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.12 719.477H343.67V725.493H344.12V719.477Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.543 720.016H342.088V726.032H342.543V720.016Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.956 719.945H340.506V725.967H340.956V719.945Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.303 719.945H338.848V725.967H339.303V719.945Z",
    fill: "#D89F3A"
  }))), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M351.57 716.621C351.57 718.904 346.384 720.762 339.99 720.762C333.596 720.762 328.416 718.904 328.416 716.621C328.416 714.338 333.596 712.469 339.99 712.469C346.384 712.469 351.57 714.322 351.57 716.621Z",
    fill: "#FFDC85"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M351.57 711.203V715.345C351.57 717.633 346.384 719.491 339.99 719.491C333.596 719.491 328.416 717.633 328.416 715.345V711.203H351.57Z",
    fill: "#DFB747"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_3346_410798",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 328,
    y: 711,
    width: 24,
    height: 9
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M351.57 711.203V715.345C351.57 717.633 346.384 719.491 339.99 719.491C333.596 719.491 328.416 717.633 328.416 715.345V711.203H351.57Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_3346_410798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.803 712.43H329.354V718.451H329.803V712.43Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.391 712.969H330.936V718.985H331.391V712.969Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.967 713.516H332.518V719.537H332.967V713.516Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.557 714.055H334.102V720.076H334.557V714.055Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.131 714.594H335.682V720.615H336.131V714.594Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.715 714.531H337.266V720.553H337.715V714.531Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.872 712.43H348.422V718.451H348.872V712.43Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.454 712.227H350.004V718.248H350.454V712.227Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.295 712.969H346.84V718.985H347.295V712.969Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.708 713.516H345.258V719.537H345.708V713.516Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.12 714.055H343.67V720.076H344.12V714.055Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.543 714.594H342.088V720.615H342.543V714.594Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.956 714.531H340.506V720.553H340.956V714.531Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.303 714.531H338.848V720.553H339.303V714.531Z",
    fill: "#D89F3A"
  }))), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M351.57 711.207C351.57 713.49 346.384 715.348 339.99 715.348C333.596 715.348 328.416 713.49 328.416 711.207C328.416 708.924 333.596 707.055 339.99 707.055C346.384 707.055 351.57 708.913 351.57 711.207Z",
    fill: "#FFDC85"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M352.701 706.102V710.243C352.701 712.531 347.515 714.395 341.121 714.395C334.727 714.395 329.547 712.537 329.547 710.243V706.102H352.701Z",
    fill: "#DFB747"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_3346_410798",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 329,
    y: 706,
    width: 24,
    height: 9
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M352.701 706.102V710.243C352.701 712.531 347.515 714.395 341.121 714.395C334.727 714.395 329.547 712.537 329.547 710.243V706.102H352.701Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_3346_410798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.934 707.328H330.479V713.344H330.934V707.328Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.516 707.875H332.061V713.891H332.516V707.875Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.092 708.406H333.643V714.428H334.092V708.406Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.68 708.953H335.23V714.975H335.68V708.953Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.262 709.492H336.812V715.508H337.262V709.492Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.844 709.422H338.395V715.443H338.844V709.422Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.004 707.328H349.549V713.344H350.004V707.328Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.579 707.125H351.129V713.141H351.579V707.125Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.415 707.875H347.965V713.891H348.415V707.875Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.833 708.406H346.383V714.428H346.833V708.406Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.251 708.953H344.801V714.975H345.251V708.953Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.674 709.492H343.219V715.508H343.674V709.492Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.086 709.422H341.637V715.443H342.086V709.422Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.426 709.422H339.977V715.443H340.426V709.422Z",
    fill: "#D89F3A"
  }))), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M352.701 706.105C352.701 708.388 347.515 710.247 341.121 710.247C334.727 710.247 329.547 708.388 329.547 706.105C329.547 703.822 334.727 701.953 341.121 701.953C347.515 701.953 352.701 703.806 352.701 706.105Z",
    fill: "#FFDC85"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M353 700.586V704.727C353 707.016 347.814 708.879 341.42 708.879C335.026 708.879 329.846 707.021 329.846 704.727V700.586H353Z",
    fill: "#DFB747"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_3346_410798",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 329,
    y: 700,
    width: 24,
    height: 9
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M353 700.586V704.727C353 707.016 347.814 708.879 341.42 708.879C335.026 708.879 329.846 707.021 329.846 704.727V700.586H353Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_3346_410798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.238 701.82H330.783V707.842H331.238V701.82Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.815 702.359H332.365V708.381H332.815V702.359Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.397 702.898H333.947V708.92H334.397V702.898Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.981 703.445H335.531V709.467H335.981V703.445Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.566 703.984H337.111V710H337.566V703.984Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.15 703.914H338.695V709.935H339.15V703.914Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.303 701.82H349.854V707.842H350.303V701.82Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.883 701.617H351.434V707.633H351.883V701.617Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.725 702.359H348.27V708.381H348.725V702.359Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.143 702.898H346.688V708.92H347.143V702.898Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.555 703.445H345.105V709.467H345.555V703.445Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.973 703.984H343.523V710H343.973V703.984Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.391 703.914H341.941V709.935H342.391V703.914Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.733 703.914H340.277V709.935H340.733V703.914Z",
    fill: "#D89F3A"
  }))), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M353 700.59C353 702.873 347.814 704.731 341.42 704.731C335.026 704.731 329.846 702.873 329.846 700.59C329.846 698.307 335.026 696.438 341.42 696.438C347.814 696.438 353 698.291 353 700.59Z",
    fill: "#FFDC85"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M353 695.18V699.316C353 701.609 347.814 703.468 341.42 703.468C335.026 703.468 329.846 701.609 329.846 699.316V695.18H353Z",
    fill: "#DFB747"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_3346_410798",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 329,
    y: 695,
    width: 24,
    height: 9
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M353 695.18V699.316C353 701.609 347.814 703.468 341.42 703.468C335.026 703.468 329.846 701.609 329.846 699.316V695.18H353Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_3346_410798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.238 696.406H330.783V702.422H331.238V696.406Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.815 696.945H332.365V702.967H332.815V696.945Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.397 697.484H333.947V703.5H334.397V697.484Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.981 698.031H335.531V704.053H335.981V698.031Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.566 698.57H337.111V704.592H337.566V698.57Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.15 698.5H338.695V704.516H339.15V698.5Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.303 696.406H349.854V702.422H350.303V696.406Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.883 696.203H351.434V702.219H351.883V696.203Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.725 696.945H348.27V702.967H348.725V696.945Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.143 697.484H346.688V703.5H347.143V697.484Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.555 698.031H345.105V704.053H345.555V698.031Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.973 698.57H343.523V704.592H343.973V698.57Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.391 698.5H341.941V704.516H342.391V698.5Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.733 698.5H340.277V704.516H340.733V698.5Z",
    fill: "#D89F3A"
  }))), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M353 695.183C353 697.466 347.814 699.319 341.42 699.319C335.026 699.319 329.846 697.466 329.846 695.183C329.846 692.901 335.026 691.031 341.42 691.031C347.814 691.031 353 692.884 353 695.183Z",
    fill: "#FFDC85"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M351.423 690.148V694.29C351.423 696.583 346.238 698.442 339.844 698.442C333.45 698.442 328.27 696.583 328.27 694.29V690.148H351.423Z",
    fill: "#DFB747"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_3346_410798",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 328,
    y: 690,
    width: 24,
    height: 9
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M351.423 690.148V694.29C351.423 696.583 346.238 698.442 339.844 698.442C333.45 698.442 328.27 696.583 328.27 694.29V690.148H351.423Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_3346_410798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.651 691.375H329.201V697.391H329.651V691.375Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.238 691.922H330.783V697.938H331.238V691.922Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.815 692.461H332.365V698.477H332.815V692.461Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.399 693H333.949V699.016H334.399V693Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.979 693.539H335.529V699.555H335.979V693.539Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.568 693.477H337.113V699.493H337.568V693.477Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.725 691.375H348.27V697.391H348.725V691.375Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.301 691.172H349.852V697.188H350.301V691.172Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.143 691.922H346.688V697.938H347.143V691.922Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.555 692.461H345.105V698.477H345.555V692.461Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.973 693H343.523V699.016H343.973V693Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.391 693.539H341.941V699.555H342.391V693.539Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.803 693.477H340.354V699.493H340.803V693.477Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.15 693.477H338.695V699.493H339.15V693.477Z",
    fill: "#D89F3A"
  }))), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M351.423 690.152C351.423 692.435 346.238 694.294 339.844 694.294C333.45 694.294 328.27 692.435 328.27 690.152C328.27 687.869 333.45 686 339.844 686C346.238 686 351.423 687.853 351.423 690.152Z",
    fill: "#FFDC85"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M351.423 684.742V688.884C351.423 691.172 346.238 693.03 339.844 693.03C333.45 693.03 328.27 691.172 328.27 688.884V684.742H351.423Z",
    fill: "#DFB747"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_3346_410798",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 328,
    y: 684,
    width: 24,
    height: 10
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M351.423 684.742V688.884C351.423 691.172 346.238 693.03 339.844 693.03C333.45 693.03 328.27 691.172 328.27 688.884V684.742H351.423Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_3346_410798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.651 685.969H329.201V691.99H329.651V685.969Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.238 686.516H330.783V692.537H331.238V686.516Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.815 687.055H332.365V693.071H332.815V687.055Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.399 687.594H333.949V693.61H334.399V687.594Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.979 688.133H335.529V694.149H335.979V688.133Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.568 688.062H337.113V694.079H337.568V688.062Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.725 685.969H348.27V691.99H348.725V685.969Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.301 685.766H349.852V691.782H350.301V685.766Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.143 686.516H346.688V692.537H347.143V686.516Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.555 687.055H345.105V693.071H345.555V687.055Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.973 687.594H343.523V693.61H343.973V687.594Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.391 688.133H341.941V694.149H342.391V688.133Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.803 688.062H340.354V694.079H340.803V688.062Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.15 688.062H338.695V694.079H339.15V688.062Z",
    fill: "#D89F3A"
  }))), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M351.423 684.746C351.423 687.029 346.238 688.887 339.844 688.887C333.45 688.887 328.27 687.029 328.27 684.746C328.27 682.463 333.45 680.594 339.844 680.594C346.238 680.594 351.423 682.447 351.423 684.746Z",
    fill: "#FFDC85"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M349.423 684.742C349.423 686.386 345.132 687.723 339.838 687.723C334.544 687.723 330.252 686.386 330.252 684.742C330.252 683.098 334.538 681.75 339.838 681.75C345.137 681.75 349.423 683.082 349.423 684.742Z",
    fill: "#FFF39F"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M339.172 611.578L342.076 614.597C343.685 616.267 341.393 621.091 336.955 625.367C332.518 629.642 327.619 631.753 326.01 630.083L323.105 627.064L339.172 611.578Z",
    fill: "#DFB747"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_3346_410798",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 323,
    y: 611,
    width: 20,
    height: 20
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M339.172 611.578L342.076 614.597C343.685 616.267 341.393 621.091 336.955 625.367C332.518 629.642 327.619 631.753 326.01 630.083L323.105 627.064L339.172 611.578Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_3346_410798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.158 631.422L328.844 631.728L324.617 627.34L324.931 627.039L329.158 631.422Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.631 630.763L330.322 631.064L326.096 626.676L326.41 626.375L330.631 630.763Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.112 630.092L331.797 630.392L327.576 626.009L327.89 625.703L332.112 630.092Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.59 629.435L333.276 629.736L329.055 625.348L329.364 625.047L333.59 629.435Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.065 628.771L334.756 629.072L330.529 624.684L330.844 624.383L335.065 628.771Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.121 627.662L335.807 627.963L331.58 623.574L331.894 623.273L336.121 627.662Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.071 618.971L342.385 618.67L338.164 614.281L337.85 614.587L342.071 618.971Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.029 617.767L343.338 617.467L339.117 613.078L338.803 613.379L343.029 617.767Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.355 620.424L341.67 620.117L337.443 615.734L337.129 616.035L341.355 620.424Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.635 621.882L340.949 621.576L336.728 617.188L336.414 617.488L340.635 621.882Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.913 623.33L340.227 623.029L336.006 618.641L335.691 618.941L339.913 623.33Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.198 624.783L339.512 624.482L335.285 620.094L334.977 620.4L339.198 624.783Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.055 625.791L338.364 625.49L334.142 621.102L333.828 621.402L338.055 625.791Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.215 626.607L336.901 626.908L332.68 622.52L332.994 622.219L337.215 626.607Z",
    fill: "#D89F3A"
  }))), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M339.171 611.574C340.775 613.24 338.478 618.063 334.045 622.339C329.608 626.615 324.709 628.726 323.105 627.06C321.49 625.384 323.783 620.566 328.22 616.291C332.653 612.015 337.557 609.899 339.166 611.574H339.171Z",
    fill: "#FFDC85"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M337.715 612.98C338.896 614.205 336.907 618.04 333.271 621.542C329.635 625.044 325.734 626.887 324.558 625.662C323.371 624.432 325.36 620.602 328.996 617.095C332.627 613.592 336.533 611.745 337.715 612.975V612.98Z",
    fill: "#FFF39F"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_3346_410798)"
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M337.566 573.126L333.794 579.123C331.709 582.442 322.853 580.673 314.017 575.174C305.188 569.666 299.716 562.518 301.808 559.197L305.572 553.202L337.564 573.119L337.566 573.126Z",
    fill: "#DFB747"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_3346_410798",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 301,
    y: 553,
    width: 37,
    height: 28
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M337.566 573.126L333.794 579.123C331.709 582.442 322.853 580.673 314.017 575.174C305.188 569.666 299.716 562.518 301.808 559.197L305.572 553.202L337.564 573.119L337.566 573.126Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_3346_410798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.892 564.895L300.269 564.505L305.743 555.79L306.374 556.178L300.892 564.895Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.587 567.035L301.965 566.646L307.439 557.931L308.069 558.319L302.587 567.035Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.282 569.191L303.66 568.802L309.132 560.079L309.762 560.467L304.282 569.191Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.978 571.332L305.355 570.943L310.829 562.228L311.452 562.617L305.978 571.332Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.671 573.481L307.049 573.091L312.523 564.376L313.153 564.764L307.671 573.481Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.921 574.746L309.298 574.357L314.771 565.634L315.402 566.03L309.921 574.746Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.615 580.912L327.238 581.301L332.719 572.584L332.089 572.196L326.615 580.912Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.986 581.982L329.609 582.371L335.09 573.655L334.46 573.267L328.986 581.982Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.937 580.334L324.56 580.723L330.034 572.008L329.411 571.618L323.937 580.334Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.258 579.755L321.88 580.145L327.354 571.429L326.732 571.04L321.258 579.755Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.58 579.177L319.203 579.566L324.676 570.851L324.054 570.462L318.58 579.177Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.9 578.599L316.523 578.988L321.997 570.273L321.374 569.884L315.9 578.599Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.768 577.138L314.398 577.526L319.872 568.811L319.249 568.422L313.768 577.138Z",
    fill: "#D89F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.107 576.098L311.484 575.709L316.958 566.993L317.581 567.383L312.107 576.098Z",
    fill: "#D89F3A"
  }))), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M337.566 573.131C335.486 576.434 326.63 574.664 317.802 569.164C308.967 563.665 303.494 556.517 305.573 553.206C307.664 549.878 316.505 551.65 325.348 557.147C334.184 562.646 339.656 569.795 337.565 573.123L337.566 573.131Z",
    fill: "#FFDC85"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M334.677 571.318C333.152 573.751 326.043 572.074 318.807 567.568C311.563 563.064 306.948 557.439 308.472 555.006C310.01 552.562 317.111 554.232 324.347 558.738C331.583 563.244 336.206 568.868 334.669 571.319L334.677 571.318Z",
    fill: "#FFF39F"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3346_410798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 730,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3346_410798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 268,
    height: 194.41,
    fill: "white",
    transform: "translate(53 206.297)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3346_410798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 234,
    fill: "white",
    transform: "translate(14 361)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_3346_410798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 369,
    height: 226,
    fill: "white",
    transform: "translate(-4.5 506)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_3346_410798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 34,
    fill: "white",
    transform: "translate(298.291 553.43) rotate(-10.1316)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreGoStopIntro1);
export default __webpack_public_path__ + "static/media/storeGoStopIntro1.56d4f97045fb3049369d8f8039ac7084.svg";
export { ForwardRef as ReactComponent };